import { CidadesDetail } from '../types'
import { cidadesRepository } from './cidadesRepository'
import { makeUseFetchOne } from '@elentari/core'

export const useCidade = makeUseFetchOne<CidadesDetail, string>({
  fetch: cidadesRepository.fetchOne
})
